import { Loader2 } from "lucide-react";
import { useUIStore } from "@/stores";

export function LoadingOverlay() {
	const { isLoading, loadingMessage } = useUIStore();

	if (!isLoading) {
		return null;
	}

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm">
			<div className="flex flex-col items-center gap-4">
				<Loader2 className="size-8 animate-spin text-primary" />
				{loadingMessage && <p className="text-sm text-muted-foreground">{loadingMessage}</p>}
			</div>
		</div>
	);
}
